webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(23),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vc_piechart_piechart__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vc_piechart_piechart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vc_piechart_piechart__);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_vc_piechart_piechart___default.a);

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  components: {
    VcStyle: __WEBPACK_IMPORTED_MODULE_1__style___default.a
  },
  data: function data() {
    return {
      total: 0,
      name: 'vc-piechart',
      id: 'vc-piechart-' + __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()(),
      parentBgColor: null
    };
  },

  props: {
    /**
     * Width and height of the chart in px, em, percentage, etc.
     */
    size: {
      type: String,
      required: false,
      default: '256px'
    },
    /**
     * Chart data array
     * [{
     *  color: String,
     *  value: Number,
     *  label: String
     * }]
     */
    data: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    /**
     * Toggle the chart legend
     */
    legend: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Optional chart title
     */
    title: {
      type: String,
      required: false
    },
    /**
     * Toggle donut mode
     */
    donut: {
      type: Boolean,
      required: false
    },
    /**
     * Toggle the chart drop shadow
     */
    flat: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    /**
     * Create the gradients for the segments
     * @computed segments
     * @return {string}
     */
    segments: function segments() {
      var _this = this;

      var gradient = 0;
      var styles = this.data.map(function (segment) {
        return segment.color + ' 0 ' + (gradient += _this.slice(segment.value)) + '%';
      });
      return 'conic-gradient(' + styles.join(',') + ')';
    }
  },
  mounted: function mounted() {
    this.onMounted();
  },

  methods: {
    /**
     * Mounted handler
     * @method onMounted
     * @return {void}
     */
    onMounted: function onMounted() {
      var noColor = 'rgba(0, 0, 0, 0)';
      var documentColor = this.getNodeCssPropertyValue();
      var parentBgColor = this.getNodeCssPropertyValue(this.$el.parentNode);
      this.setChartTotal();
      if (parentBgColor === noColor) {
        parentBgColor = documentColor === noColor ? '#fff' : documentColor;
      }
      this.parentBgColor = parentBgColor;
    },

    /**
     * Return chart series slice
     * @method slice
     * @param {number} value [value=0]
     * @return {number}
     */
    slice: function slice() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      return this.total === 0 ? 0 : Math.round(value * 100 / this.total);
    },

    /**
     * Get chart totals
     * @method setChartTotal
     * @return {void}
     */
    setChartTotal: function setChartTotal() {
      var _this2 = this;

      this.data.forEach(function (bar) {
        _this2.total = _this2.total + bar.value;
      });
    },

    /**
     * Create a label out of the item.label and item.value
     * @method label
     * @param {object} item
     * @return {string}
     */
    label: function label() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (item) {
        return item.label + ' (' + item.value + ')';
      }
    },

    /**
     * Get a computed CSS property value from an element
     * @method getNodeCssPropertyValue
     * @param {Element} node [node=document.body]
     * @param {string} property [property='background-color']
     * @return {string}
     */
    getNodeCssPropertyValue: function getNodeCssPropertyValue() {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
      var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'background-color';

      return window.getComputedStyle(node, null).getPropertyValue(property);
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VcStyle',
  render: function render(createElement) {
    return createElement('style', this.$slots.default);
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('div', {
    class: [_vm.name, _vm.flat ? (_vm.name + "-flat") : null],
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.title) ? _c('div', {
    class: [(_vm.name + "-title")],
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [(_vm.name + "-container")]
  }, [(_vm.donut) ? _c('div', {
    class: [(_vm.name + "-donut")]
  }) : _vm._e()]), _vm._v(" "), (_vm.legend) ? _c('ul', {
    class: [(_vm.name + "-legend")]
  }, _vm._l((_vm.data), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      style: ({
        background: item.color
      })
    }), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.label(item))
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('vc-style', [_vm._v("\n  #" + _vm._s(_vm.id) + ",\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-container\n  {\n    width: " + _vm._s(_vm.size) + ";\n  }\n\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-container\n  {\n    height: " + _vm._s(_vm.size) + ";\n  }\n\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-container\n  {\n    background: " + _vm._s(_vm.segments) + ";\n  }\n\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-donut\n  {\n    background: " + _vm._s(_vm.parentBgColor) + ";\n    width: calc(" + _vm._s(_vm.size) + " / 2.5);\n    height: calc(" + _vm._s(_vm.size) + " / 2.5);\n  }\n  ")])], 1) : _vm._e()
},staticRenderFns: []}

/***/ })
],[7]);


// WEBPACK FOOTER //
// docs/js/vc-piechart.831ea4c27da20551b1b8.js